import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";
import Logo from "../../images/logo.svg";
import { totalPrice } from "../../utils";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import sIcon from "../../images/add-to-cart.svg";
import ChangeLang from "./ChangeLang";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthProvider";
import AuthModal from "../AuthModal/AuthModal";

const Header = (props) => {
  const { t } = useTranslation();
  const [menuActive, setMenuState] = useState(false);
  const [cartActive, setcartState] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false); 
  const { currentUser } = useContext(AuthContext);

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const handleLoginClick = (e) => {
    e.preventDefault();
    setAuthModalOpen(true);
  };

  const handleCloseLoginModal = () => {
    setAuthModalOpen(false);
  };

  const { carts } = props;

  return (
    <>
      <header id="header" className={props.hclass}>
        <div className="wpo-site-header">
          <nav className="navigation navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-3 col-1 d-lg-none dl-block">
                  <MobileMenu />
                </div>
                <div className="col-lg-2 col-md-6 col-7">
                  <div className="navbar-header d-flex align-items-center">
                    <Link
                      onClick={ClickHandler}
                      className="navbar-brand d-flex align-items-center"
                      to="/home"
                    >
                      <img
                        src={Logo}
                        alt="logo"
                        style={{
                          width: "400px",
                          height: "auto",
                          maxWidth: "200%",
                        }}
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-8 col-md-1 col-1">
                  <div
                    id="navbar"
                    className="collapse navbar-collapse navigation-holder"
                  >
                    <button className="menu-close">
                      <i className="ti-close"></i>
                    </button>
                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                      <li className="menu-item-has-children">
                        <Link onClick={ClickHandler} className="active" to="/">
                          <span className="main-title">{t(`home`)}</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={ClickHandler} to="/about">
                          <span className="main-title">{t(`about`)}</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={ClickHandler} to="/contact">
                          <span className="main-title">{t(`contact`)}</span>
                        </Link>
                      </li>
                      <li>
                        <Link onClick={ClickHandler} to="/privacy-policy">
                          <span className="main-title">
                            {t("privacy_policy")}
                          </span>
                        </Link>
                      </li>
                      {currentUser ? (
                        <>
                          <li>
                            <Link onClick={ClickHandler} to="/logout">
                              <span className="main-title">{t(`logout`)}</span>
                            </Link>
                          </li>
                        </>
                      ) : (
                        <>
                          <li>
                            <a href="#" onClick={handleLoginClick}>
                              <span className="main-title">{t(`login`)}</span>
                            </a>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-2 col-md-2 col-3 header-right">
                  <div className="header-search-form-wrapper">
                    <div className="cart-search-contact">
                      <button
                        onClick={() => setMenuState(!menuActive)}
                        className="search-toggle-btn"
                      >
                        <i
                          className={`fi ti-search ${
                            menuActive ? "ti-close" : "fi "
                          }`}
                        ></i>
                      </button>
                      <div
                        className={`header-search-form ${
                          menuActive ? "header-search-content-toggle" : ""
                        }`}
                        role="search"
                      >
                        <form onSubmit={SubmitHandler} className="search-form">
                          <div className="search-input-wrapper">
                            <input
                              type="text"
                              className="form-control search-input"
                              placeholder={t(`searchPlaceholder`)}
                              aria-label="Search"
                            />
                            <button
                              type="submit"
                              className="search-submit-btn"
                              aria-label="Submit Search"
                            >
                              <i
                                className="fi flaticon-loupe"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      margin: "0 10px",
                    }}
                  >
                    <ChangeLang />
                  </div>
                  <div className="mini-cart">
                    <button
                      className="cart-toggle-btn"
                      onClick={() => setcartState(!cartActive)}
                    >
                      {" "}
                      <i>
                        <img src={sIcon} alt="" />
                      </i>{" "}
                      <span className="cart-count">{carts.length}</span>
                    </button>

                    <div
                      style={{
                        background: "#fff",
                        width: "320px",
                        height: "100vh",
                        zIndex: 100,
                        position: "fixed",
                        right: cartActive ? "0" : "-320px",
                        top: "0",
                        opacity: cartActive ? 1 : 0,
                        visibility: cartActive ? "visible" : "hidden",
                        transition: "all 0.5s ease",
                        boxShadow: "-2px 18px 40px -9px rgba(153, 153, 153, 1)",
                        overflowY: "auto",
                      }}
                    >
                      <button
                        style={{
                          display: "block",
                          width: "40px",
                          height: "40px",
                          backgroundColor: "rgb(51, 51, 51)",
                          color: "rgb(255, 255, 255)",
                          fontSize: "0px",
                          textAlign: "center",
                          overflow: "hidden",
                          position: "relative",
                          float: "right",
                          lineHeight: "54px",
                          borderRadius: "3px",
                          right: "10px",
                          top: "20px",
                        }}
                        onClick={() => setcartState(!cartActive)}
                      >
                        <i
                          className="ti-close"
                          style={{ fontSize: "15px" }}
                        ></i>
                      </button>

                      <div
                        style={{
                          padding: "100px 20px 25px",
                          maxHeight: "60vh",
                          overflowY: "auto",
                        }}
                      >
                        {carts &&
                          carts.length > 0 &&
                          carts.map((catItem, crt) => (
                            <div
                              key={crt}
                              style={{
                                paddingTop: "15px",
                                marginTop: "15px",
                                borderTop: "1px solid #efefef",
                              }}
                            >
                              <div
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  border: "2px solid #f3f3f3",
                                  float: "left",
                                  marginRight: "15px",
                                }}
                              >
                                <img
                                  src={catItem.proImg}
                                  alt="icon"
                                  style={{
                                    display: "block",
                                    width: "46px",
                                    height: "46px",
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  paddingRight: "20px",
                                  position: "relative",
                                  overflow: "hidden",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: 500,
                                    color: "#333",
                                    margin: 0,
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {catItem.title}
                                </p>
                                <span
                                  style={{
                                    fontSize: "13px",
                                    color: "#888",
                                    display: "block",
                                    marginTop: "3px",
                                  }}
                                >
                                  {catItem.price} × {catItem.qty}{" "}
                                  {t("currency")}
                                </span>
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "#444",
                                    display: "block",
                                    position: "absolute",
                                    right: 0,
                                    top: "6px",
                                  }}
                                >
                                  <button
                                    onClick={() =>
                                      props.removeFromCart(catItem.id, t)
                                    }
                                    style={{
                                      background: "transparent",
                                      border: "none",
                                      padding: 0,
                                    }}
                                  >
                                    <i
                                      className="ti-close"
                                      style={{
                                        padding: "2px",
                                        background: "#f3f3f3",
                                        borderRadius: "3px",
                                        fontSize: "12px",
                                      }}
                                    ></i>
                                  </button>
                                </span>
                              </div>
                            </div>
                          ))}
                      </div>

                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          position: "sticky",
                          bottom: 0,
                          background: "#fff",
                          borderTop: "1px solid #ddd",
                          width: "100%",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "#333",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "20px",
                          }}
                        >
                          {t("subtotal")}:
                          <span style={{ color: "#c79652", fontSize: "20px" }}>
                            {totalPrice(carts)} {t("currency")}
                          </span>
                        </span>
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "240px",
                            margin: "0 auto",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          <Link
                            to="/checkout"
                            style={{
                              display: "block",
                              width: "100%",
                              padding: "10px 20px",
                              textAlign: "center",
                              borderRadius: "5px",
                              background: "#ddd",
                              color: "#333",
                              textDecoration: "none",
                            }}
                          >
                            {t("checkout")}
                          </Link>
                          <Link
                            to="/cart"
                            style={{
                              display: "block",
                              width: "100%",
                              padding: "10px 20px",
                              textAlign: "center",
                              borderRadius: "5px",
                              background: "#c79652",
                              color: "#fff",
                              textDecoration: "none",
                            }}
                          >
                            {t("viewCart")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* Login Modal */}
      <AuthModal open={authModalOpen} handleClose={handleCloseLoginModal} />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
  };
};

export default connect(mapStateToProps, { removeFromCart })(Header);
